const LoadingSpinner = ({ size = 24, className = '' }) => {
    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div
                className="animate-spin rounded-full border-2 border-mono-200 border-t-black dark:border-mono-700 dark:border-t-white"
                style={{ width: size, height: size }}
            />
        </div>
    );
};

export default LoadingSpinner;
